import { signInWithCustomToken } from '@firebase/auth';
import { firebaseAuth } from '../firebase/init';
import { Auth } from '@firebase/auth';

export async function firebaseSignInWithCustomToken(customToken?: string) {
  if (!customToken) {
    throw new Error('Missing sign-in token');
  }
  return signInWithCustomToken(firebaseAuth, customToken);
}

export async function getFirebaseToken() {
  return firebaseAuth.currentUser?.getIdToken();
}

export async function firebaseTokenExists() {
  const token = await getFirebaseToken();
  return !!token;
}

export function firebaseAuthChange(
  ...params: Parameters<Auth['onAuthStateChanged']>
) {
  firebaseAuth.onAuthStateChanged(...params);
}

export function userIsLoggedIn() {
  return !!firebaseAuth.currentUser;
}
